import { css } from "lit";

export const createPostModalStyles = css`
  .modal-content {
    width: 100%;
    max-width: 730px;
    margin: 0 auto;

    display: flex;
    overflow: hidden;
  }

  .form-layout {
    display: grid;
    gap: 40px;
    overflow: hidden;
  }

  /* Desktop: single row, 2 columns */
  @media (min-width: 768px) {
    .form-layout {
      grid-template-areas: "left-column switches";
      grid-template-columns: 1fr 1fr;
    }

    .left-column,
    .switches-container {
      overflow-y: auto;
      max-height: calc(90vh - 200px); /* Account for header, footer, and padding */
    }
  }

  /* Mobile: single column stack */
  @media (max-width: 767px) {
    .modal-content {
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .form-layout {
      overflow: auto;
      grid-template-areas:
        "left-column"
        "switches";
      grid-template-columns: 1fr;
    }

    /* Ensure columns don't have individual scrolling on mobile */
    .left-column,
    .switches-container {
      overflow: visible;
      max-height: none;
    }
  }

  .left-column {
    grid-area: left-column;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .switches-container {
    grid-area: switches;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  media-uploader {
    height: unset;
  }

  .media-upload-container {
    position: relative;
    /* Ensure proper containment on mobile */
    overflow: hidden;
  }

  media-uploader {
    height: unset;
  }

  /* Mobile-specific adjustments for media uploader within modal */
  @media (max-width: 767px) {
    .media-upload-container {
      /* Prevent media uploader from expanding beyond modal bounds */
      max-width: 100%;
      max-height: 50vh;
    }

    /* Ensure media uploader respects mobile modal constraints */
    .left-column media-uploader {
      max-height: 50vh;
    }
  }

  .picture-placeholder {
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    border-radius: var(--sds-size-radius-400);
    border: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    aspect-ratio: 1;
    cursor: pointer;
    transition: border-color 0.2s ease;
  }

  .picture-placeholder:hover {
    border-color: var(--sds-color-border-default-hover);
  }

  .picture-placeholder ph-image {
    color: #7c7c7c;
  }

  .picture-placeholder-text {
    color: #7c7c7c;
    font-size: var(--sds-size-text-body-medium-font-size);
    font-weight: var(--sds-size-text-body-medium-font-weight);
    line-height: var(--sds-size-text-body-medium-line-height);
  }

  .description-field {
    width: 100%;
  }

  .form-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .field-label {
    font-size: var(--sds-size-text-body-small-font-size);
    font-weight: var(--sds-size-text-body-small-font-weight);
    line-height: var(--sds-size-text-body-small-line-height);
    color: var(--sds-color-text-default-primary);
  }

  .cta-inputs {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .switch-list {
    display: flex;
    flex-direction: column;
    gap: 8px 0;
  }

  .switch-list wow-switch {
    width: 100%;
  }

  /* CTA Fields Animation Container */
  .cta-fields-container {
    overflow: hidden;
    interpolate-size: allow-keywords;
    transition:
      height 0.3s ease,
      display 0.3s allow-discrete;
  }

  .cta-fields-content {
    padding: 16px 0 0 0;
    transition: opacity 0.2s ease 0.1s;
  }

  /* Starting style for when element first appears */
  @starting-style {
    .cta-fields-container {
      height: 0;
      opacity: 0;
    }

    .cta-fields-content {
      opacity: 0;
    }
  }

  /* Form fields inside CTA container */
  .cta-fields-content .form-field {
    margin-bottom: 16px;
  }

  .cta-fields-content .form-field:last-child {
    margin-bottom: 0;
  }

  /* Discount Fields Animation Container */
  .discount-fields-container {
    overflow: hidden;
    interpolate-size: allow-keywords;
    transition:
      height 0.3s ease,
      display 0.3s allow-discrete;
  }

  .discount-fields-content {
    padding: 16px 0 0 0;
    transition: opacity 0.2s ease 0.1s;
  }

  /* Starting style for when discount fields first appear */
  @starting-style {
    .discount-fields-container {
      height: 0;
      opacity: 0;
    }

    .discount-fields-content {
      opacity: 0;
    }
  }

  /* Form fields inside discount container */
  .discount-fields-content .form-field {
    margin-bottom: 16px;
  }

  .discount-fields-content .form-field:last-child {
    margin-bottom: 0;
  }

  /* FAQ Blocks Container */
  .faq-blocks-container {
    display: flex;
    flex-direction: column;
    gap: 16px;

    /* Enable container size animations */
    interpolate-size: allow-keywords;
    transition: height 0.3s ease;
  }

  /* Add FAQ Link */
  .add-faq-link {
    color: var(--sds-color-text-default-tertiary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.5;
    text-decoration-line: underline;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    align-self: flex-start;
  }

  .add-faq-link:hover {
    color: var(--sds-color-text-default-secondary);
  }
`;

export const thumbnailStyles = css`
  .thumbnail-overlay {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(187deg, rgb(17 17 17 / 0.8) 3.03%, rgb(17 17 17 / 0) 30.16%),
      linear-gradient(202deg, rgb(17 17 17 / 0) 25.48%, rgb(17 17 17 / 0.8) 74.88%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: var(--sds-size-space-400);
  }

  .worlds-text {
    color: var(--sds-color-white-800);
    text-align: center;
    font-family: var(--sds-typography-family-title);
    font-size: 13px;
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
  }

  .overlay-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-300);
  }

  .overlay-description {
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-body);
    font-size: 10px;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.5;
  }

  .overlay-faq-text {
    color: var(--sds-color-white-800);
    font-family: var(--sds-typography-family-body);
    font-size: 8px;
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.5;
  }

  .premium-section {
    margin-top: var(--spacing-4, 1rem);
    padding-top: var(--spacing-4, 1rem);
    border-top: 1px solid var(--sds-color-border-default-default, #e0e0e0);
  }
`;
